import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=72c15752&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Header.vue?vue&type=style&index=0&id=72c15752&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "72c15752",
  null
  ,true
)

export default component.exports